// src/config/demoRetailers.js
//
// Seed entries for the demo-day retailer dropdown (Nigel 2026-07-23:
// "prepopulate the retailer from our known list" — the same retailers the
// web store shows when a board is out of stock).
//
// SOURCE OF TRUTH: waka-theme/assets/waka-inventory.js → RETAILERS_BY_MARKET
// (the PDP "check with our retailers" panel; names + URLs supplied by Nigel,
// last updated there 2026-07-07), plus retailers Nigel supplies directly
// (Windance, 2026-07-23 — not on the PDP list). Keep in sync BY HAND when the
// theme list changes — never add a retailer whose URL wasn't given by Nigel
// or taken from the theme list.
//
// Retailer product pages are size-agnostic (the rider picks a size on their
// page), so every Glide size maps to the same URL. Seeds appear in the
// dropdown immediately; picking one materialises it into the Firestore
// catalogue (demoRetailers/) so it becomes admin-editable like any other.
// An admin can hide a seed by saving it with active: false.

const GLIDE_SIZES = ['66', '77', '88', '99', '111'];
const allSizes = (url) => Object.fromEntries(GLIDE_SIZES.map((s) => [s, url]));

export const SEED_RETAILERS = [
  {
    id: 'mackite-boardsports',
    name: 'MACkite Boardsports',
    boardUrlsBySize: allSizes('https://www.mackiteboarding.com/2025-waka-glide-v1-foil-board/'),
    seed: true,
  },
  {
    id: 'green-hat-kiteboarding',
    name: 'Green Hat Kiteboarding',
    boardUrlsBySize: allSizes('https://greenhatkiteboarding.com/products/waka-glide-folding-foilboard'),
    seed: true,
  },
  {
    // Supplied by Nigel 2026-07-23 (URL verified live; Shopify search-tracking
    // params stripped). Not on the PDP retailer panel — demo partner.
    id: 'windance',
    name: 'Windance Boardsports',
    boardUrlsBySize: allSizes('https://www.windance.com/products/waka-glide-folding-foil-board-2026'),
    seed: true,
  },
  {
    // CA-market retailer on the PDP — shown here too; the admin decides
    // per-event whether an offer applies.
    id: '30-noeuds',
    name: '30 Noeuds',
    boardUrlsBySize: allSizes('https://30noeuds.com/products/waka-glide-folding-foil-board'),
    seed: true,
  },
];
